module.exports = __webpack_public_path__ + "static/media/defaultNotification.e434f6c8.jpg";